export default {"src":"/_next/static/image/src/assets/nav/menu-burger.3fe7542cee3e86d6e98c7430d36c38ce.svg","height":24,"width":24};